import React, { FC, ReactNode } from "react";
import "./style.scss";

interface TitleProps {
  level?: "large" | "1" | "2" | "3" | "4";
  children: ReactNode;
  className?: string;
}

const TextBody: FC<TitleProps> = ({
  level = "large",
  children,
  className = "",
}) => {
  return <div className={`body-${level} ${className}`}>{children}</div>;
};

export default TextBody;
